module.exports = __webpack_public_path__ + "d1c9bdaa38481ec587f761ded61d137d.png";